// TODO: change name to assessmentsApi b/c it contains hooks but is not a hook
import useGetApi from "../../useGetApi"
import useMutateApi from '../../useMutateApi'

// constants
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"

// utils
import getUrl from 'api/apiMap'

// other apis
import { useGetRequestTypes } from "api/hooks/requests/useRequestTypesApi"

const useGetRequestType = (id) => {
  return useGetApi(getUrl(`${apiEndpoints.requestTypes}${id}/`), queryKeys.requestTypes.detail(id))
}

const useGetRequestAdditionaFields = (id) => {
  return useGetApi(getUrl(`${apiEndpoints.requestTypes}${id}/schema`), queryKeys.requestTypes.schemaDetail(id))
}

const usePostRequestType = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(`${apiEndpoints.requestTypes}`),
    invalidateQueries: [queryKeys.requestTypesList],
    successMsg: 'Successfully created workflow'
  })
}

const usePutRequestType = () => {
  return useMutateApi({
    method: "put",
    apiEndpoint: getUrl(`${apiEndpoints.requestTypes}`),
    invalidateQueries: [queryKeys.requestTypesList],
    successMsg: 'Successfully updated workflow'
  })
}

export {
  useGetRequestTypes,
  useGetRequestType,
  useGetRequestAdditionaFields,
  usePostRequestType,
  usePutRequestType,
}